import { useApp } from '@/app/AppContext'

/**
 * Заглушка раздела, экраны которого появятся в следующих тикетах (#48–#50).
 *
 * Названа заглушкой явно и на экране тоже: пустая страница без объяснения читается
 * как поломка, и её приходят чинить.
 */
export function Placeholder({ titleKey }: { titleKey: string }) {
  const { t } = useApp()
  return (
    <section>
      <h1>{t(titleKey)}</h1>
      <p className="muted">{t('page.placeholder')}</p>
    </section>
  )
}
